module.exports = __webpack_public_path__ + "assets/img/rank1.c9663d7c.png";